<template>
  <div>
    <div class="stockli__form-intro bkgr-woman-smiling">
      <div class="stockli__form-intro--text black-trans-bkgr ">
        <div class="h4 white-text mb-0">Your Setting</div>
      </div>
    </div>

    
    <div class="stockli__form-container">
      <div class="progress-indicator mt-0">
        <router-link to="/info">
          <div class="step-indicator active">Contact Info</div>
        </router-link>
        <div class="step-line active"></div>
        <router-link to="/calculator">
          <div class="step-indicator active">Release Preference</div>
        </router-link>
        <div class="step-line active"></div>
        <div class="step-indicator active">Your Setting</div>
        <div class="step-line"></div>
        <div class="step-indicator">Submit</div>
      </div>
      
      <div class="stockli__form--indicator-result black-trans-bkgr pa-6">
        <div class="h2 white-text">Your Indicator Setting:</div>
        <div class="indicator-result">{{ Indicator_Setting }}</div>
        <p class="bold-text">
          If from experience, you have been dissatisfied with the release settings that result from your release preference, you can change them here:
          
        </p>
        <p>
          <router-link :to="{ name: 'CustomIndicator' }" class="btn">Override my release setting</router-link>
        </p>
      </div>
      <div class="h3 mb-6">Almost Done!</div>
      <p>Please read and, if you agree, accept the Demo Terms and Conditions.</p>
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="Submit">
        <!-- Terms dialog box -->
        <v-dialog v-model="termsDialogOpen" scrollable max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <div class="mt-4 mb-4">
              <v-btn v-bind="attrs" v-on="on">Read Demo Terms and Conditions</v-btn>
            </div>
          </template>
          <v-card>
            <v-card-title>DEMO EVENT PARTICIPATION AGREEMENT AND RELEASE AND WAIVER OF LIABILITY ("RELEASE")</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div class="py-5">
                <p>I understand that the sports of skiing (including, but not limited to, alpine and backcountry skiing and mountain touring), and other sports (collectively "RECREATIONAL SNOW SPORTS") involve inherent and other risks of INJURY and DEATH. I voluntarily agree to expressly assume all risks of injury or death that may result from these RECREATIONAL SNOW SPORTS, or which relate in any way to the participation in the Demo Event ("the Event"). I understand that a helmet designed for RECREATIONAL SNOW SPORTS use, when sized and fitted properly, will help reduce the risk of some types of injuries to the user at slower speeds. I recognize that serious injury or death can result from both low and high-energy impacts, even when a helmet is worn; and a damaged helmet should not be used, as damage may compromise the effectiveness of the helmet.</p>
                <p>I agree to accept for use AS IS all equipment to be provided to me during this Event, and I agree to accept full financial responsibility for the care of the equipment while it is in my possession. I further agree to be responsible for the replacement at full retail value of any equipment I receive, but do not return upon request, even if it is lost or stolen.</p>
                <p>I understand that the ski/binding/boot system cannot guarantee the user's safety. In skiing with skis equipped with release bindings, the ski/binding/boot system will not always release or under all circumstances where release may prevent injury or death, nor is it possible to predict every situation in which it will release. I understand that additional risk of injury may result if I use visual indicator settings other than those recommended by Stockli USA Inc. or Stoeckli Swiss Sports AG. I understand that there are no actual or implied safety of ski/binding/boot systems or guarantee of release. I understand that mountain touring bindings are not to be confused with alpine bindings and understand that these types of binding systems do not have indicator settings. I voluntarily agree and expressly assume all risks of injury or death that may result from using any binding system during the Event.</p>
                <p>Knowing this, and in consideration of being permitted to participate in Event, I AGREE TO RELEASE AND HOLD HARMLESS the Location event premises owners and operators, the owners, manufacturers and distributors of equipment including Stockli USA Inc., Stoeckli Swiss Sports AG, Salomon and their respective employees, affiliates (including but not limited to, Stockli USA Inc. or Stoeckli Swiss Sports), agents, officers, directors and their successors in interest (collectively "PROVIDERS") from all liability for injury, death, property loss and damage which results from the equipment user's participation in the RECREATIONAL SNOW SPORTS for which the equipment is provided, or which is related in any way to the use of this equipment, including all liability that results from the NEGLIGENCE of PROVIDERS, or any other person or cause, or otherwise resulting from or arising out of my participation in the Event.</p>
                <p>I have also been informed and understand that PROVIDERS may be producing photographs, videos, films, audio, or other media at the Event and that my name, likeness, image, voice, appearance and/or performance is being recorded and may or may not be made part of PROVIDERS' production.</p>
                <p>I hereby consent that the photographs, video, film, or audio of me or any reproductions thereof taken by PROVIDERS, or its assigned vendors, may be used by PROVIDERS, or its assigns, without time constraints, for the purpose of illustration, catalog, website, television, promotion, advertising, or publication in any manner and in any media now known or later developed. I understand that I will not have any interest or ownership in PROVIDERS' production and that I will not receive any compensation from PROVIDERS for the use of my name, likeness, image, voice, appearance, and/or performance. The grant of rights herein shall be worldwide and perpetual.</p>
                <p>I understand and agree that I am releasing not only the entities set forth in the paragraph above, but also the parents, subsidiaries, affiliates, officers, directors, agents, employees, and other similarly related parties of those entities. I further agree to defend and indemnify PROVIDERS for any loss or damage, including any that results from claims or lawsuits for personal injury, death, and property loss and damage related in any way to the use of this equipment or my grant of rights herein.</p>
                <p>If the equipment user is a minor, the user's parent or guardian signature is required, and that parent or guardian agrees to be bound by the conditions of this agreement and to indemnify PROVIDERS for any claim or lawsuit allegedly arising out of the use of the equipment provided or the grant of rights. The parent or guardian agrees to pay PROVIDERS all costs and legal fees expended defending against such claims or lawsuits as well as any sum paid because of any judgment or settlement.</p>
                <p>This agreement is governed by the applicable law of the state or province of the Location. If any provision of this agreement is determined to be unenforceable, all other provisions shall be given full force and effect.</p>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn text @click="termsDialogOpen = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Parent / Guardian stuff -->
        <div v-if="Has_Guardian">
          <v-row dense>
            <v-col cols="12">
              <v-checkbox v-model="Agree" :rules="[ruleRequired]">
                <template v-slot:label>
                  I, the parent or guardian, hereby represent and certify that I am the parent or legal guardian of {{ First_Name }} {{ Last_Name }},
                  who is now {{ Age }} years of age and who is in good health and has no special problems associated with his/her care.
                  I, the parent/guardian, execute this Release for my child, myself and my heirs, successors, representatives, and assigns.
                  I give my permission for my minor child to participate in the Event(s).
                  I certify that I have read the Terms &amp; Conditions and fully understand that I am not relying on any statements
                  or representations of any party released hereby.
                  I understand that all the terms and conditions contained therein also apply to my child's participation in this Event.
                  I further understand that I must be present during the entire time of my child's participation in the Event.
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </div>

        <div v-else>
          <v-row dense>
            <v-col cols="12">
              <v-checkbox v-model="Agree" label="I am at least 18 years of age and I have read this Release and agree to its Terms and Conditions." :rules="[ruleRequired]" />
            </v-col>
          </v-row>
        </div>
        <v-alert type="error" v-if="submitError">{{ submitError }}</v-alert>
        <v-row dense class="mt-5">
          <v-col cols="4" sm="3">
            <v-btn type="submit" :loading="submitting" :disabled="submitting">Submit</v-btn>
          </v-col>
          <v-col>
            <div v-if="!valid" class="validation-error-message">Please correct the errors above before submitting.</div>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

import API from "@/services/api";
import { Utilities } from "@/services/utilities";

export default {
  name: "CalculatorResult",
  components: {
  },
  data: () => ({
    submitting: false,
    submitError: null,

    valid: undefined,
    ruleRequired: v => !!v || "This field is required",

    termsDialogOpen: false,
  }),
  computed: {
    // Vuex is convoluted to alter values. This plugin simplifies direct binding to object properties in the store.
    ...mapFields([
      "skierInfo.Indicator_Setting",
      "skierInfo.Age",
      "skierInfo.First_Name",
      "skierInfo.Last_Name",
      "skierInfo.Has_Guardian",
      "skierInfo.Agree",
    ]),
    skierInfo() {
      return this.$store.state.skierInfo;
    },
  },
  async mounted() {
  },
  methods: {
    async Submit() {
      if (!this.$refs.form.validate()) return;

      this.submitting = true;
      this.submitError = null;
      try {
        // Shallow clone skier info
        const postInfo = Object.assign({}, this.skierInfo);
        // Unmask phone numbers if possible
        if (postInfo.Mobile && postInfo.Mobile.length === 17) {
          postInfo.Mobile = Utilities.UnmaskPhone(postInfo.Mobile);
        }
        if (postInfo.Guardian_Phone && postInfo.Guardian_Phone.length === 17) {
          postInfo.Guardian_Phone = Utilities.UnmaskPhone(postInfo.Guardian_Phone);
        }
        // Add sole units if possible
        if (postInfo.Sole && postInfo.Sole.length === 3) {
          postInfo.Sole += "mm";
        }
        // Tell the API to create a CRM record
        await API.CreatePreregister(postInfo);
        // Clear the skier form info, but save the indicator
        this.$store.commit("SetSavedIndicator", this.skierInfo.Indicator_Setting);
        this.$store.commit("ClearSkierInfo");
        try {
          /* global fbq */
          fbq("track", "CompleteRegistration");
        } catch {
          // Ignore if facebook pixel is not available
        }
        this.$router.push({ name: "Complete" });
      } catch (err) {
        this.submitError = "Sorry, there was a problem submitting your info. Please try again."
        if (err.response && err.response.data && err.response.data.message) {
          console.error(err.response.data.message);
        }
        throw err;
      } finally {
        this.submitting = false;
      }
    },
  },
}
</script>
<style scoped lang="scss">
</style>
